var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"fill-height main",attrs:{"id":"layout"}},[(_vm.env !== 'production')?_c('div',{staticClass:"ribbon ribbon-top-left"},[_c('span',[_vm._v("DEMO")])]):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }